import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { TableHeaderRightBlockDirective } from '@app/modules/table/children/table-header/directives/table-header-right-block.directive';
import { TableHeaderTitleDirective } from '@app/modules/table/children/table-header/directives/table-header-title.directive';
import { ButtonModule } from '@components/button/modules/button.module';
import { FuiButtonsPanelComponent } from '@fui/fui-components';
import { TableHeaderComponent } from '../components/table-header.component';
import { PopupContentComponent } from '@components/popup-content/popup-content.component';

@NgModule({
    declarations: [TableHeaderComponent, TableHeaderTitleDirective, TableHeaderRightBlockDirective],
    exports: [TableHeaderComponent, TableHeaderTitleDirective, TableHeaderRightBlockDirective],
    imports: [
        CommonModule,
        ButtonModule,
        MatMenuModule,
        MatIconModule,
        FuiButtonsPanelComponent,
        PopupContentComponent,
    ],
})
export class TableHeaderModule {}
